module.exports = "/fonts/vendor/vue-pdf-app/dist/icons/pdf.ttf?11e2353a39982587486727580357d307";